import { defineStore } from "pinia";
import { thirdCarrierService } from "@/_services";

export const thirdCarrierStore = defineStore("thirdCarrier", {
  state: () => ({
    thirdCarriers: [],
    error: null,
  }),

  actions: {
    searchThirdCarriers(name) {
      this.error = null;
      const query = name
        ? { name: { $regex: name, $options: "i" } }
        : {};
      return thirdCarrierService
        .getThirdCarriers({ page: 1, limit: 10 }, query, { _id: -1 })
        .then((result) => {
          this.thirdCarriers = result?.data || [];
          return this.thirdCarriers;
        })
        .catch((reason) => {
          this.error = reason;
          throw reason;
        });
    },
  },
});
